import React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@omni/components/components/Account/AccountButton/accountButton.container"
    ).then((module) => ({ default: module.AccountButtonContainer }))
);
